import { connect } from 'react-redux';

const GreetingContainer = ({ user: { firstName } }) => `Welcome, ${firstName}`;

function mapStateToProps(state) {
  return {
    user: state.auth.profile
  };
}

export default connect(mapStateToProps)(GreetingContainer);



// WEBPACK FOOTER //
// ./src/containers/greeting/greeting.jsx